export default __webpack_public_path__ + "edbc2da4c30084a31455852526aab84a.svg";